/**
 * Data Entry route — the Assumptions Hub.
 *
 * Access is gated at the route level by <RequireAssumptions> (see App.tsx),
 * so anyone who reaches this component is in the `assumptions` group. The
 * feature itself lives in src/assumptions/.
 */
import AssumptionsApp from "../assumptions/AssumptionsApp";

export function DataEntry() {
  return <AssumptionsApp />;
}
